import {
	TaxPage,
	SettingsSubscription,
	CreateShop,
	Crypto,
	AddManager,
	ShoppingCart,
	Managers,
	Personal,
	Payments,
	Design,
	ShopGeneralSettings,
	Notification,
	SecurityPage,
	UserGeneralSettings,
	Fraud,
	SettingsAffiliate,
	GatewayFees,
	Currencies,
	Shopify,
} from '../screens'


const settingsRoute = [
	{
		path: `/settings/general`,
		component: UserGeneralSettings,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Details',
		},
			title: 'Settings - Details',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/create/shop`,
		component: CreateShop,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Create Shop',
		},
			title: 'Create Shop',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/security`,
		component: SecurityPage,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Security',
		},
			title: 'Settings - Security',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/notifications`,
		component: Notification,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Notifications',
		},
			title: 'Settings - Notifications',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/personal`,
		component: Personal,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Personal',
		},
			title: 'Settings - Personal',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/personal`,
		component: Personal,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Personal',
		},
			title: 'Settings - Personal',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/general`,
		component: ShopGeneralSettings,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Details',
		},
			title: 'Settings - Details',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/managers`,
		component: Managers,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Manage',
		},
			title: 'Settings - Manage',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/payments`,
		component: Payments,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Payments',
		},
			title: 'Settings - Payments',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/crypto`,
		component: Crypto,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Crypto',
		},
			title: 'Settings - Crypto',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/affiliate`,
		component: SettingsAffiliate,
		metadata: {
			description: "Affiliate Settings.",
			title: 'Settings - Affiliate',
		},
			title: 'Settings - Affiliate',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/cart`,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Shopping Cart',
		},
			title: 'Settings - Shopping Cart',
		component: ShoppingCart,
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/subscription`,
		component: SettingsSubscription,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Product Subscription',
		},
			title: 'Settings - Product Subscription',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/design`,
		component: Design,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Design',
		},
			title: 'Settings - Design',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/tax`,
		component: TaxPage,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Tax',
		},
			title: 'Settings - Tax',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/fraud`,
		component: Fraud,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Fraud',
		},
			title: 'Settings - Fraud',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/gateway-fees`,
		component: GatewayFees,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Gateway Adjustments',
		},
		title: 'Settings - Gateway Adjustments',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/currencies`,
		component: Currencies,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Currencies',
		},
		title: 'Settings - Currencies',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/shop/shopify`,
		component: Shopify,
		metadata: {
			description: "Customize your shop, update your security details, access a full audit log of every action on your account and more on your Dashboard Settings page.",
			title: 'Settings - Shopify',
		},
		title: 'Settings - Shopify',
		exact: true,
		noindex: true,
	},
	{
		path: `/settings/`,
		pathTo: `/settings/general`,
		noindex: true,
		redirect: true,
	},
]

export default settingsRoute